import http from '@/http'

const BASE = (participantId) => `/admin/participants/${participantId}/financials`

export const listFinancials = (participantId, params = {}) => http.get(BASE(participantId), { params })
export const storeFinancial = (participantId, payload) => http.post(BASE(participantId), payload)
export const updateFinancial = (participantId, id, payload) => http.put(`${BASE(participantId)}/${id}`, payload)
export const destroyFinancial = (participantId, id) => http.delete(`${BASE(participantId)}/${id}`)
export const exportFinancials = (participantId) => http.get(`${BASE(participantId)}/export`, { responseType: 'blob' })

export const getFinancialSettings = () => http.get('/admin/settings/financial-control')

export default {
  listFinancials,
  storeFinancial,
  updateFinancial,
  destroyFinancial,
  exportFinancials,
  getFinancialSettings
}
